import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  SimulacaoFinanciamentoRequest,
  SimulacaoFinanciamentoResponse
} from '../models/simulacao-financiamento.model';
import { SimulacaoFinanciamentoRepository } from '../repositories/simulacao-financiamento.repository';

@Injectable({ providedIn: 'root' })
export class SimulacaoFinanciamentoService implements SimulacaoFinanciamentoRepository {
  private readonly endpoint = `${environment.FI_FINANC_IMOB_BE}simulacao-financiamento`;

  constructor(private readonly http: HttpClient) {}

  consultarMargens(request: SimulacaoFinanciamentoRequest): Observable<SimulacaoFinanciamentoResponse> {
    return this.http.post<SimulacaoFinanciamentoResponse>(`${this.endpoint}/margens`, request);
  }

  simular(request: SimulacaoFinanciamentoRequest): Observable<SimulacaoFinanciamentoResponse> {
    return this.http.post<SimulacaoFinanciamentoResponse>(this.endpoint, request);
  }
}
